// extracted by mini-css-extract-plugin
export default {"timerLabelWrapper":"AttentionLimitWidget_timerLabelWrapper","timerWrapper":"AttentionLimitWidget_timerWrapper"};